import script from "./content-header.vue?vue&type=script&lang=ts&setup=true"
export * from "./content-header.vue?vue&type=script&lang=ts&setup=true"

import "./content-header.vue?vue&type=style&index=0&id=4b4d845e&lang=scss&scoped=true"

import exportComponent from "/builds/snedson/snotra-backend/snotra-front-ts/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4b4d845e"]])

export default __exports__